import { __assign, __rest } from "tslib";
/* eslint-disable camelcase*/
import { RicosBILogger } from './RicosBILogger';
import uuid from './uuid';
import * as E from '@wix/bi-logger-rich-editor/v2';
var onPluginActionMap = {
    addPluginLink: E.addPluginLink,
    searchForPlugin: E.searchForPlugin,
    searchInsideThePlugin: E.searchInsideThePlugin,
    pluginTableColumnRowAction: E.pluginTableColumnRowAction,
    tablePluginAddColumnRow: E.tablePluginAddColumnRow,
    tablePluginDeleteColumnRow: E.tablePluginDeleteColumnRow,
    tablePluginClickOnOptionMenu: E.tablePluginClickOnOptionMenu,
    tablePluginClickActionFromOptionMenu: E.tablePluginClickActionFromOptionMenu,
    settingsModalOpenedForPlugin: E.settingsModalOpenedForPlugin,
    settingsModalClosedForPlugin: E.settingsModalClosedForPlugin,
};
var rce_session_id = uuid();
export var ricosBICallbacks = function (_a) {
    var _b = _a.consumer, container = _b === void 0 ? 'default' : _b, _c = _a.appDefId, container_id = _c === void 0 ? 'empty' : _c, container_platform = _a.platform, container_usage = _a.usage, postId = _a.postId, wixRicosVersion = _a.wixRicosVersion, metaSiteId = _a.metaSiteId, webBiLogger = _a.webBiLogger, logger = _a.logger, _d = _a.defaultParams, essentials = _d === void 0 ? {} : _d;
    var genericParams = {
        container: container,
        container_id: container_id,
        container_platform: container_platform,
        container_usage: container_usage,
        post_id: postId,
        rce_session_id: rce_session_id,
        msid: metaSiteId,
        wixRicosVersion: wixRicosVersion,
    };
    var biLogger = new RicosBILogger({ logger: logger, webBiLogger: webBiLogger, genericParams: genericParams, essentials: essentials });
    return {
        onPluginAdd: function (plugin_id, entry_point, version, content_id) {
            return biLogger.log(E.addPlugin, {
                plugin_id: plugin_id,
                search_term: undefined,
                entry_point: entry_point,
                version: version,
                content_id: content_id,
                entry_type: undefined,
                plugins_details: undefined,
                pluginUniqueId: undefined,
                button_name: undefined,
            });
        },
        onPluginAddStep: function (_a) {
            var entryPoint = _a.entryPoint, entryType = _a.entryType, pluginDetails = _a.pluginDetails, pluginId = _a.pluginId, step = _a.step, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.addPluginStep, {
                entry_point: entryPoint,
                entry_type: entryType,
                params: undefined,
                plugin_id: pluginId,
                pluginUniqueId: pluginDetails,
                plugins_details: undefined,
                step: step,
                version: version,
                content_id: content_id,
            });
        },
        onPluginAddSuccess: function (plugin_id, entry_point, params, version, content_id) {
            return biLogger.log(E.addPluginSuccess, {
                plugin_id: plugin_id,
                entry_point: entry_point,
                entry_type: undefined,
                params: JSON.stringify(params),
                plugins_details: undefined,
                pluginUniqueId: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onPluginDelete: function (_a) {
            var pluginId = _a.pluginId, pluginDetails = _a.pluginDetails, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.deletePlugin, {
                plugin_id: pluginId,
                plugins_details: JSON.stringify(pluginDetails || {}),
                pluginUniqueId: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onPluginChange: function (plugin_id, pluginDetails, version, content_id) {
            return biLogger.log(E.changePlugin, {
                plugin_id: plugin_id,
                plugins_details: JSON.stringify(pluginDetails),
                settingSessionId: undefined,
                button_name: undefined,
                category: undefined,
                origin: undefined,
                type: undefined,
                value: undefined,
                pluginUniqueId: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onPublish: function (post_id, plugins_count, _plugins_details, version, content_id) {
            return biLogger.log(E.publishPost, {
                post_id: post_id || postId,
                plugins_count: plugins_count ? JSON.stringify(plugins_count) : undefined,
                plugins_details: '',
                params: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onMenuLoad: function (_a) {
            var menu = _a.menu, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.menuLoad, {
                menu: menu,
                version: version,
                content_id: content_id,
            });
        },
        onPluginModalOpened: function (_a) {
            var entryPoint = _a.entryPoint, entryType = _a.entryType, pluginDetails = _a.pluginDetails, pluginId = _a.pluginId, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.pluginModalOpened, {
                entry_point: entryPoint,
                entry_type: entryType,
                plugin_id: pluginId,
                plugins_details: JSON.stringify(pluginDetails),
                version: version,
                content_id: content_id,
            });
        },
        onViewerAction: function (plugin_id, action_name, value, content_id) {
            return biLogger.log(E.viewerAction, {
                action_name: action_name,
                plugin_id: plugin_id,
                value: value,
                plugins_details: undefined,
                pluginUniqueId: undefined,
                content_id: content_id,
                params: undefined,
                productType: undefined,
            });
        },
        onViewerLoaded: function (_a) {
            var isPreview = _a.isPreview, postURL = _a.url, pluginsCount = _a.pluginsCount, version = _a.version, content_id = _a.contentId;
            // Enforcement fix for a boolean `isPreview` value
            var preview = typeof isPreview === 'boolean'
                ? isPreview
                : typeof isPreview === 'string' && isPreview === 'true';
            biLogger.log(E.viewerLoaded, {
                preview: preview,
                postURL: postURL,
                version: version,
                content_id: content_id,
                pluginsCount: JSON.stringify(pluginsCount),
            });
        },
        onOpenEditorSuccess: function (version, toolbarType, content_id) {
            return biLogger.log(E.openEditorSuccess, {
                toolbarType: toolbarType,
                version: version,
                content_id: content_id,
            });
        },
        onContentEdited: function (_a) {
            var version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.contentAdded, {
                version: version,
                content_id: content_id,
                contact_id: undefined,
                container_type: undefined,
                editing_time: undefined,
                paragraph_count: undefined,
                word_count: undefined,
            });
        },
        onInlineToolbarOpen: function (_a) {
            var version = _a.version, toolbarType = _a.toolbarType, pluginId = _a.pluginId, content_id = _a.contentId;
            return biLogger.log(E.inlineToolbarOpened, {
                version: version,
                content_id: content_id,
                toolbarType: toolbarType,
                plugin_id: pluginId,
            });
        },
        onToolbarButtonClick: function (_a) {
            var buttonName = _a.buttonName, category = _a.category, origin = _a.origin, pluginDetails = _a.pluginDetails, pluginId = _a.pluginId, pluginUniqueId = _a.pluginUniqueId, type = _a.type, value = _a.value, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.changePlugin, {
                button_name: buttonName,
                category: category,
                origin: origin,
                pluginUniqueId: pluginUniqueId,
                plugin_id: pluginId,
                plugins_details: pluginDetails,
                type: type,
                value: value,
                version: version,
                content_id: content_id,
                settingSessionId: undefined,
            });
        },
        onKeyboardShortcutAction: function (_a) {
            var buttonName = _a.buttonName, pluginId = _a.pluginId, value = _a.value, version = _a.version, content_id = _a.contentId;
            return biLogger.log(E.keyboardShortcutAction, {
                button_name: buttonName,
                category: undefined,
                origin: undefined,
                pluginUniqueId: undefined,
                plugin_id: pluginId,
                plugins_details: undefined,
                type: undefined,
                value: value,
                version: version,
                content_id: content_id,
                settingSessionId: undefined,
            });
        },
        onMediaUploadStart: function (correlationId, plugin_id, fileSize, mediaType, version, content_id) {
            biLogger.log(E.uploadMediaTry, {
                plugin_id: plugin_id,
                correlationId: correlationId,
                fileSize: fileSize,
                mediaType: mediaType,
                type: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onMediaUploadEnd: function (correlationId, plugin_id, duration, fileSize, mediaType, isSuccess, errorReason, version, content_id) {
            biLogger.log(E.uploadMediaFinished, {
                plugin_id: plugin_id,
                correlationId: correlationId,
                duration: duration,
                fileSize: fileSize,
                mediaType: mediaType,
                isSuccess: isSuccess,
                errorReason: errorReason,
                type: undefined,
                version: version,
                content_id: content_id,
            });
        },
        onPluginAction: function (eventName, eventParams) {
            if (eventParams.params) {
                var params = JSON.stringify(eventParams.params);
                eventParams.params = params;
            }
            var _a = eventParams || {}, content_id = _a.contentId, rest = __rest(_a, ["contentId"]);
            biLogger.log(onPluginActionMap[eventName], __assign({ content_id: content_id, version: undefined, plugins_details: undefined }, rest));
        },
        onPluginsPopOverTabSwitch: function (_a) {
            var pluginId = _a.pluginId, buttonName = _a.buttonName, version = _a.version, content_id = _a.contentId;
            biLogger.log(E.pluginsPopoverTabSwitch, {
                plugin_id: pluginId,
                button_name: buttonName,
                content_id: content_id,
                version: version,
                plugins_details: undefined,
                pluginUniqueId: undefined,
                settingSessionId: undefined,
                category: undefined,
                origin: undefined,
                value: undefined,
                type: undefined,
            });
        },
        onPluginsPopOverClick: function (_a) {
            var pluginId = _a.pluginId, buttonName = _a.buttonName, version = _a.version, content_id = _a.contentId;
            biLogger.log(E.pluginsPopoverClick, {
                plugin_id: pluginId,
                button_name: buttonName,
                content_id: content_id,
                version: version,
                plugins_details: undefined,
                pluginUniqueId: undefined,
                settingSessionId: undefined,
                category: undefined,
                origin: undefined,
                value: undefined,
                type: undefined,
            });
        },
        onChangePluginSettings: function (_a) {
            var pluginId = _a.pluginId, actionName = _a.actionName, value = _a.value, version = _a.version, content_id = _a.contentId;
            biLogger.log(E.changePluginSettings, {
                plugin_id: pluginId,
                actionName: actionName,
                content_id: content_id,
                value: value,
                version: version,
                container: undefined,
                container_id: undefined,
                container_platform: undefined,
                entry_point: undefined,
                entry_type: undefined,
                layout: undefined,
                params: value,
                pluginUniqueId: undefined,
                plugins_details: undefined,
            });
        },
        mediaPluginsDetails: function (_a) {
            var pluginId = _a.pluginId, creator = _a.creator, title = _a.title, track_duration = _a.track_duration, url = _a.url, type = _a.type, version = _a.version, content_id = _a.contentId;
            biLogger.log(E.audioPluginDetails, {
                plugin_id: pluginId,
                creator: creator,
                title: title,
                track_duration: track_duration === null || track_duration === void 0 ? void 0 : track_duration.toString(),
                url: url,
                type: type,
                version: version,
                content_id: content_id,
                pluginUniqueId: undefined,
                container: undefined,
                container_id: undefined,
                container_platform: undefined,
                params: undefined,
            });
        },
    };
};
//# sourceMappingURL=ricosBICallbacks.js.map